const environment = window.gon.reactAppEnv
const environmentLikeProduction = ["production", "staging", "sandbox"]
const isProductionEnvironment = environment === "production"

export const config = {
  endpoints: {
    app: `${window.location.protocol}//${window.location.host}`,
  },
  environment,
  get environmentIsProductionLike() {
    return environment !== undefined && environmentLikeProduction.includes(environment)
  },
  isProductionEnvironment,
  nonProductionEnvironment: !isProductionEnvironment,
  isTestEnvironment: environment === "test",
}
